import { useSignal } from "@preact/signals-react";

import Loading from "componentsv2/widgets/Loading";
import ModalForm from "componentsv2/modal/ModalForm";
import { useStore, insertRecord } from "storev2/formStore";
// import Pagination from "./Pagination";

/**
 * Component for create table with body and header
 *
 * @param {object} props - component props
 * @param {boolean} props.sortable - boolean define if column is sortable
 * @param {Objetc} props.layout - define model view
 * @param {Array} props.records - Array of records to fill in
 * @param {function} props.updateRecords - Function for update records parent
 * @param {function} props.onClickRow - Function for handle event onClickRow
 * @param {function} props.onClickCell - Function for handle event onClickCell
 * @param {boolean} props.paginate - Define if table is paginate
 * @return {Component} - table component
 */
function GridCards(props) {
  const { layout, model, records, reload, isLoading, Card } = props;
  // const { setRecord } = useStore();
  console.log("Layotu ....", layout);
  const storeId = useSignal(null);
  const openModalForm = useSignal(false);

  function handleDelete(record) {
    props.handleDelete(record);
  }

  function onClose() {
    openModalForm.value = false;
    if (reload) {
      reload();
    }
  }

  async function onClick(record) {
    if (record.id > 0) {
      storeId.value = await insertRecord(record.id, model, layout);
      // await setRecord(record.id, model, layout);
      // selectedRecord.value = record.id;
      // console.log("WTF onClick called", storeId.value);
    }
    openModalForm.value = true;
  }

  if (isLoading) return <Loading />;

  return (
    <div id="grid-cards" className="pt-3 overflow-x-scroll">
      {records.map((rec, idx) => {
        return (
          <Card
            key={idx}
            layout={layout}
            record={rec}
            onClick={onClick}
            handleDelete={handleDelete}
          />
        );
      })}
      {openModalForm.value && storeId.value && (
        <ModalForm
          openModal={openModalForm}
          size={layout.sizeModal || "h-9/10 w-screen md:w-4/5"}
          storeId={storeId.value}
          layout={layout}
          onClose={onClose}
        />
      )}
    </div>
  );
}

export default GridCards;
